import { useEffect, useState } from 'react'

import { hasUserRejectedAllTracking } from 'utils/cookieYesConsent'

/**
 * GTM'in yüklenip yüklenmeyeceğine karar verir (kasko-nextjs `useDeferredGtm` / `ensureGtmLoaded`
 * paritesi, CONSENT_GATE_ENABLED=false modu):
 *  - `enabled=false` → her zaman true (davranış değişmez).
 *  - `enabled=true`  → tüm tracking kategorilerini açıkça reddetmiş kullanıcıda GTM yüklenmez;
 *    karar yok (örtülü model) veya en az bir tracking kategorisi kabul → yüklenir.
 *    Kullanıcı sonradan kabul ederse (`cookieyes_consent_update`) GTM o anda yüklenir;
 *    kabulden sonra ret ise GTM yüklü kalır, sinyaller Consent Mode ile denied'a çekilir.
 *
 * SSR'da ve ilk client render'da `enabled` host'lar için false döner (hydration uyumu); karar
 * mount sonrasında cookie'den verilir.
 */
const useCookieYesGtmGate = (enabled: boolean): boolean => {
  const [allowed, setAllowed] = useState(!enabled)

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') return undefined

    const evaluate = (): void => {
      if (!hasUserRejectedAllTracking()) setAllowed(true)
    }

    evaluate()
    document.addEventListener('cookieyes_banner_load', evaluate)
    document.addEventListener('cookieyes_consent_update', evaluate)

    return () => {
      document.removeEventListener('cookieyes_banner_load', evaluate)
      document.removeEventListener('cookieyes_consent_update', evaluate)
    }
  }, [enabled])

  return enabled ? allowed : true
}

export default useCookieYesGtmGate
